import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { createOnboardingDataSlice } from './onboarding-data'
import { OnboardingDataSlice } from './type'

export const useBoundStore = create<OnboardingDataSlice>()(
  persist(
    (...a) => ({
      ...createOnboardingDataSlice(...a),
    }),
    {
      name: 'template-store',
    },
  ),
)
